import React from 'react';
import { renderIntoContainer, unmountContainer } from 'react/root/containerRoot';
import Toasts from 'react/toasts/Toasts';

export const INFO_TOAST_MILLISECONDS = 6000;

// The site's toasts, for things that happen away from what the user is
// looking at: friends coming online, mentions, errors with no control on
// screen. Anything with a control on screen answers in place instead.
// The stack mounts into the page on first use, so jQuery pages can call it.
let toasts = [];
let nextId = 1;
let container = null;
const timers = new Map();

function render() {
	if(!container) {
		container = document.createElement('div');
		document.body.appendChild(container);
	}
	renderIntoContainer(<Toasts toasts={toasts} onDismiss={dismissToast} />, container);
}

/**
 * @param {object} toast
 * @param {React.ReactNode} toast.content
 * @param {'info'|'warning'} [toast.kind] info closes itself; warning stays until dismissed
 * @param {{username: string}} [toast.user] shows the user's initial beside the content
 * @returns {number} the toast's id, for dismissToast
 */
export function showToast({ content, kind = 'info', user = null }) {
	const id = nextId++;
	toasts = [...toasts, { id, content, kind, user }];
	if(kind === 'info') {
		timers.set(id, setTimeout(() => dismissToast(id), INFO_TOAST_MILLISECONDS));
	}
	render();
	return id;
}

export function dismissToast(id) {
	clearTimeout(timers.get(id));
	timers.delete(id);
	toasts = toasts.filter((toast) => toast.id !== id);
	render();
}

export function clearToasts() {
	timers.forEach((timer) => clearTimeout(timer));
	timers.clear();
	toasts = [];
	if(container) {
		unmountContainer(container);
		container.remove();
		container = null;
	}
}
